var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPencilCrossedIconSv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon pencil-crossed-icon",
    viewBox: "0 0 6.35 6.35",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.103.103a.353.353 0 01.499 0l5.64 5.64a.353.353 0 11-.498.5L.104.601a.353.353 0 010-.499zm1.88 5.532a.118.118 0 01-.037.024L.31 6.333a.224.224 0 01-.292-.293L.69 4.404a.113.113 0 01.025-.037L4.82.263A.896.896 0 116.087 1.53zm2.52-4.422l-3.17 3.17.634.634 3.17-3.17-.634-.634zM5.137.58L4.82.897l.634.633.317-.317A.448.448 0 105.137.58zM1.043 4.726l-.407.988.988-.407z"
  })));
}

export default SvgPencilCrossedIconSv;